<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный домен {{currentDomain.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteDomain()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionDomainModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.IS_CONFIRM_DELETION_DOMAIN_MODAL_OPENED;
      },
      set(){
        this.$store.dispatch('CONFIRM_DELETION_DOMAIN_MODAL', false);
      }
    },
    currentDomain: {
      get(){
        return this.$store.getters.GET_CURRENT_DOMAIN;
      },
      set(value){
        this.$store.commit("SET_CURRENT_DOMAIN", value);
      }
    },
  },
  methods: {
    close() {
      this.$store.dispatch('CONFIRM_DELETION_DOMAIN_MODAL', false);
    },
    deleteDomain(){
      this.$store.dispatch('DELETE_DOMAIN', this.currentDomain.id)
        .then(() => {
          this.$toast.success('Домен был удален');
          this.$store.dispatch("GET_DOMAINS");
          this.$store.dispatch('CONFIRM_DELETION_DOMAIN_MODAL', false);
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    }
  },
};
</script>
